import { render, staticRenderFns } from "./CaringChildrenSurvey.vue?vue&type=template&id=471c6f63"
import script from "./CaringChildrenSurvey.vue?vue&type=script&lang=ts"
export * from "./CaringChildrenSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports